import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable, postConstruct } from 'mana-syringe';
import { HookHub } from '@antv/xflow-hook';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowGraphCommands } from '../constant';
/** 从服务端获取画布数据命令 */
export var NsGraphLoadData;
(function (NsGraphLoadData) {
    /** Command: 用于注册named factory */
    NsGraphLoadData.command = XFlowGraphCommands.LOAD_DATA;
    /** hookName */
    NsGraphLoadData.hookKey = 'loadData';
    NsGraphLoadData.createHook = () => {
        return new HookHub();
    };
})(NsGraphLoadData || (NsGraphLoadData = {}));
let GraphLoadDataCommand = class GraphLoadDataCommand {
    constructor() {
        /** 执行cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const { args, hooks: runtimeHook } = this.ctx.getArgs();
            const hooks = this.ctx.getHooks();
            const result = yield hooks.loadData.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const { loadDataService } = handlerArgs;
                const graphMeta = yield this.ctx.getGraphMeta();
                const graphData = yield loadDataService(graphMeta);
                return { graphData };
            }), runtimeHook);
            /** 设置结果 */
            this.ctx.setResult(result);
            return this;
        });
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.ctx.isUndoable) {
                yield this.execute();
            }
            return this;
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    isUndoable() {
        return this.ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], GraphLoadDataCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], GraphLoadDataCommand.prototype, "init", null);
GraphLoadDataCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsGraphLoadData.command.id },
    })
    /** 画布数据获取命令 */
], GraphLoadDataCommand);
export { GraphLoadDataCommand };
//# sourceMappingURL=graph-load-data.js.map